import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import './ProjectListLayout.scss';
import { Constants } from '@pwc/pwc-deals-web-common';
import { getUserFeatureEnabled } from '../../services/userFeatureToggleService';
import { getProject } from '../../../features/project/projectSlice';

const ProjectListLayout = ({ children }) => {
  const project = useSelector(getProject);
  useEffect(() => {
    let isMounted = true;
    const launch = async () => {
      if (project.id) {
        await getUserFeatureEnabled(
          project.id,
          Constants.FEATURE_NAMES.WELCOME_BOX
        );
      }
    };

    if (isMounted) {
      launch();
    }

    return () => {
      isMounted = false;
    };
  }, [project.id]);
  return (
    <div className="project-list-layout">
      <div className="project-list">{children}</div>
    </div>
  );
};

export default ProjectListLayout;
